import { render, staticRenderFns } from "./DownlineRepCheckPaymentAddressContent.vue?vue&type=template&id=f963fb04&"
import script from "./DownlineRepCheckPaymentAddressContent.vue?vue&type=script&lang=js&"
export * from "./DownlineRepCheckPaymentAddressContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports